import { PujcovnaVozidel } from './pujcovnaVozidel';
import { StavPujcovny } from './stavPujcovny';
import { SkladPredmetu } from './skladPredmetu';
import { SkladoveMistoPredmetu } from './skladoveMistoPredmetu';
import { ZarazeniPujcovnaPredmet } from './zarazeniPujcovnaPredmet';
import { ZarazeniPujcovnaVozidlo } from './zarazeniPujcovnaVozidlo';

export const menu = {
	name: 'CiselnikPujcovna',
	list: [
		{ name: 'VpaVaria', route: ZarazeniPujcovnaVozidlo.name },
		{ name: 'OpaVaria', route: ZarazeniPujcovnaPredmet.name },
		{ name: 'APUJ_Pujcovna', route: PujcovnaVozidel.name },
		{ name: 'StavPujcovny', route: StavPujcovny.name },
		{ name: 'SkladPredmetu', route: SkladPredmetu.name },
		{ name: 'SkladoveMistoPredmetu', route: SkladoveMistoPredmetu.name },
	],
};
